

const sleep = () => new Promise<void>((resolve) => setTimeout(() => resolve(), 250))

export const fileUtils = {

    downloadPdf: async (base64: string, fileName: string) => {

        const PDF_PREFIX = 'data:application/pdf;base64,';
        const url = PDF_PREFIX + base64;

        const tmpAnchor = document.createElement('a');
        tmpAnchor.style.display = 'none';

        document.body.appendChild(tmpAnchor);
        tmpAnchor.href = url;
        tmpAnchor.download = fileName
        const clickReturn = tmpAnchor.click();
        document.body.removeChild(tmpAnchor);
        await sleep();

        return clickReturn
    }
} as const;





